import {
  userForPage,
  delUser,
  municipalTree,
  getMunicipalTreeById,
  updateMunicipalTreeById,
  updateUser
} from '@/api/systemManage'

export const service = {
  getMunicipalTreeById(params) {
    return new Promise((resolve, reject) => {
      getMunicipalTreeById(params)
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateMunicipalTreeById(params) {
    return new Promise((resolve, reject) => {
      updateMunicipalTreeById(params)
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  municipalTree() {
    return new Promise((resolve, reject) => {
      municipalTree()
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  userForPage(data) {
    const params = data || {}
    return new Promise((resolve, reject) => {
      userForPage(params)
        .then((response) => {
          if (response) {
            const data = response.records || []
            const total = response.total || 0
            resolve({ data, total })
          } else {
            resolve({})
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  delUser(data) {
    const params = data || {}
    return new Promise((resolve, reject) => {
      delUser(params)
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateUser(data) {
    return new Promise((resolve, reject) => {
      updateUser(data)
        .then((response) => {
          if (response) {
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
